import React from 'react'
import { observer } from 'mobx-react'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { AvatarLabelGroup, Badge } from '@flowwai-frontend/design-system'

import { SearchResultType } from '../../../types'

import { itemContainerClassName } from '../styles'
import { GlobalSearchType } from '../../../types/index'

interface Props {
   gsResult: SearchResultType
   onClickGSResultItem: (
      pipelineItemId: string,
      pipelineItemName?: string
   ) => void
}

const GSResultItem = (props: Props): React.ReactElement => {
   const { gsResult, onClickGSResultItem } = props

   const { theme } = useAppTheme()
   const { searchResultItemHoverColor } = theme.globalSearch.searchModal

   const isNotTemplateSearchType =
      (Config.GLOBAL_SEARCH_TYPE as GlobalSearchType) !== 'TEMPLATE'

   const onClickItem = () => {
      onClickGSResultItem(gsResult.pipelineItemId)
   }

   return (
      <div
         onClick={onClickItem}
         className={`${itemContainerClassName} ${searchResultItemHoverColor}`}
         data-testid={`gs-result-item-${gsResult.pipelineItemId}`}
      >
         <div className='max-w-[50%]' data-testid='gs-result-name'>
            <AvatarLabelGroup
               name={gsResult.name}
               type={'Text'}
               shape={'Circular'}
               size={'Medium'}
            />
         </div>
         {isNotTemplateSearchType && gsResult.stage ? (
            <div className='max-w-[50%]' data-testid='gs-result-stage'>
               <Badge size='Small' variant={gsResult.stage?.color ?? 'GRAY'}>
                  {gsResult.stage.name}
               </Badge>
            </div>
         ) : null}
      </div>
   )
}

export default observer(GSResultItem)
